// Pages a signed-in person may open before their employee profile is complete.
// The invitation must stay here: Sign in from that page has to come back to
// Accept invitation, not to My Requests.
export const PROFILE_GATE_ALLOWED_PREFIXES = [
  '/hr/my-portal',
  '/login',
  '/logout',
  '/accept-company-invite',
]

/**
 * Return why the employee profile-completion redirect must not run.
 *
 * The redirect target requires hr.me.view. Running the gate before the auth
 * context is hydrated, or for a user without that permission, can bounce
 * forever between the dashboard and profile routes.
 *
 * @param {object} authStore
 * @returns {string|null}
 */
export function profileCompletionGateBlockReason(authStore) {
  if (!authStore?.user || !authStore?.domain) {
    return 'auth context is not hydrated'
  }
  if (authStore.permissionsHydrated === false || !Array.isArray(authStore.permissions)) {
    return 'permissions are not hydrated'
  }
  if (!authStore.hasPermission('hr.me.view')) {
    return 'hr.me.view is not available'
  }
  return null
}
